<template>
  <div>
    <video-pop-up />
    <drawer @toggleSidebar="toggleSidebar" :sidebar="sidebar" />
    <!--====== HEADER PART START ======-->
    <header-one image="logo.png" @toggleSidebar="toggleSidebar" />
    <!--====== HEADER PART ENDS ======-->

    <!--====== POST PART START ======-->

    <!--
    <post-part-home-one />
    -->

    <!--====== POST PART ENDS ======-->

    <!--====== POST GALLERY PART START ======-->
  
    <post-gallery />

    <single-ad />


    <div class="container mt-20">
      <icon-news />
    </div>

    <div class="container mt-20 mb-30">
      <two-news />
    </div>

    <div class="container mt-20 mb-30">
     <div class="bg-white-shadow text-center pt-40 pb-30">
        <div class="h2 mb-40">联系我们</div>
        <p>
          地址：北京市西城区复兴门内大街45号院<br />
          <!-- 电话：<a href="tel:13520158992">13520158992</a> -->
        </p>
      </div>
    </div>

    <!--====== FOOTER PART START ======-->
    <footer-one />

    <!--====== FOOTER PART ENDS ======-->

    <!--====== GO TO TOP PART START ======-->
    <div class="go-top-area" style="display: none;">
      <div class="go-top-wrap">
        <div class="go-top-btn-wrap">
          <a href="#" class="go-top go-top-btn d-block">
            <i class="fa fa-angle-double-up"></i>
            <i class="fa fa-angle-double-up"></i>
          </a>
        </div>
      </div>
    </div>

    <floating-buttons />

  </div>
</template>
<script>
import HeaderOne from "../Utility/Header/index";
// import PostPartHomeOne from "./PostPartHomeOne.vue";
import PostGallery from "./PostGallery.vue";
import TwoNews from "./TwoNews.vue";
import IconNews from "./IconNews.vue";
// import Features from "./Features.vue";
// import TrendingNews from "./TrendingNews.vue";
// import SinglePlayPost from "./SinglePlayPost.vue";
// import VideoNews from "./VideoNews.vue";
// import EntertainmentNews from "./EntertainmentNews.vue";
// import SportsNews from "./SportsNews.vue";
// import BuisnessNews from "./BuisnessNews.vue";
// import SharePost from "./SharePost.vue";
import FooterOne from "../Utility/Footer/FooterOne.vue";
import Drawer from "../Mobile/Drawer.vue";
import VideoPopUp from "../Utility/VideoPopUp.vue";
// import SignupStyleTwo from "../Utility/Signup/SignupStyleTwo.vue";
import SingleAd from "../Common/SingleAd.vue";
import FloatingButtons from "@/components/Common/FloatingButtons.vue";
export default {
  components: {
    VideoPopUp,
    Drawer,
    HeaderOne,
    // PostPartHomeOne,
    PostGallery,
    TwoNews,
    IconNews,
    SingleAd,
    // Features,
    // TrendingNews,
    // SinglePlayPost,
    // VideoNews,
    // EntertainmentNews,
    // SportsNews,
    // BuisnessNews,
    // SharePost,
    FooterOne,
    // SignupStyleTwo,
    FloatingButtons
  },
  inject: ['dataWrapper', 'fetchStatus'],
  data: () => ({
    sidebar: false,
    news:[],
    isLoading:true
  }),
  created() {
    document.addEventListener("scroll", this.topToBottom);
  },
  watch: {
    'fetchStatus.isFetched': {
      handler(newVal) {
        if (newVal) {
          this.news = Array.isArray(this.dataWrapper.articles) 
            ? this.dataWrapper.articles.filter(item => item.orgchannel === '8').slice(0, 6) 
            : [];
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    toggleSidebar() {
      this.sidebar = !this.sidebar;
    },
    topToBottom() {
      const result = document.querySelector(".go-top");
      if (
        document.body.scrollTop > window.innerHeight ||
        document.documentElement.scrollTop > window.innerHeight
      ) {
        result.classList.add("active");
      } else {
        result.classList.remove("active");
      }
    },
  },
};
</script>

<style scoped>
/* play post */
.single-play-post-area .single-play-box {
  padding: 23px 12px !important;
}
.custom-corp-img {
  width: 100px;
  height: auto;
  object-fit: cover; /* 保持图片比例，覆盖整个容器 */
  object-position: center; /* 显示图片中心部分 */
}

.upcoming-matches-flag {
  width: 100px; /* 设置固定宽度 */
  flex-shrink: 0; /* 禁止收缩 */
}
.h2 {
  font-size: 34px;
  font-weight: 700;
}

</style>
